export enum AnchorDirection {
    LEFT = `left`,
    RIGHT = `right`,
    TOP = `top`,
    BOTTOM = `bottom`,
}